import React from "react";
import { useSelector } from "react-redux";
import LifeStyle from "../../service-steps/clinical-assessment/life-style";
import VaccineCards from "../../service-steps/health-wellness/vaccine-cards";
import { calculateAgeYear } from "../../../../../helpers/functions";

const HealthAndWellness = () => {
  const { clinicalServiceObj } = useSelector((state) => state.clinicalService);
  const { patient } = useSelector((state) => state.patients);
  const isUnder12 = patient?.dateOfBirth && calculateAgeYear(patient.dateOfBirth) < 12;
  const { currentSubStep } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;

  const renderStep = () => {
    const subStep = currentSubStep;
    switch (subStep) {
      case 1:
        // Skip Lifestyle for patients under 12 and render next step
        if (isUnder12) return <VaccineCards fromHealthAndWellness={true} />;
        return <LifeStyle />;
      case 2:
        return <VaccineCards fromHealthAndWellness={true} />;
    }
  };
  return renderStep();
};

export default HealthAndWellness;
